export default __webpack_public_path__ + "static/media/PROCESSMETHOD_MOLDING_DOUBLE_INJECTION.c2c2a1df.png";